exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".userPermissionTable td {\n  text-align: center;\n}\n", "", {"version":3,"sources":["/home/guille/chinespain/tripmaker-redux/src/app/users/PermissionsTable.less","/home/guille/chinespain/tripmaker-redux/src/app/users/PermissionsTable.less"],"names":[],"mappings":"AAAA;EACE,mBAAA;CCCD","file":"PermissionsTable.less","sourcesContent":[".userPermissionTable td {\n  text-align: center;\n}",".userPermissionTable td {\n  text-align: center;\n}\n"],"sourceRoot":""}]);

// exports
